import React from 'react'
import SeoPage from '../components/SeoPage'

import Img from '../components/Image'
import { graphql, Link } from 'gatsby'

const ContentPage = ({ data, location, ...props }) => {
    return (
        <SeoPage
            leadImage={data.img0.childImageSharp.fluid.src}
            location={location}
            title="La défense de type Carter peut-elle être invoquée en 2025 pour alcool au volant?"
            description="Vous avez été arrêté pour alcool au volant ? Nous vous expliquons la défense de type Carter et si elle peut être invoquée en 2025 pour cette infraction !"
            fr={undefined}
            lawType="criminal"
            specialtyText="pour alcool au volant">
            <p>
                En pratique, la défense Carter est de moins en moins utilisée et
                reconnue dans le cadre d’accusations pour conduite avec les
                facultés affaiblies.{' '}
            </p>
            <p>
                La défense Carter permettait à une personne interceptée au
                volant d’un véhicule avec un taux d’alcool supérieure à la
                limite permise de soulever un doute raisonnable grâce à des
                témoins ou grâce à des caractéristiques personnelles.
            </p>
            <p>
                <Img
                    fluid={data.img0.childImageSharp.fluid}
                    title="Conduite avec les facultés affaiblies par l’alcool!"
                    alt=""
                />
            </p>
            <h2>
                Toutefois, depuis plusieurs années, les règles relatives au
                doute raisonnable dans le cadre d’une accusation pour conduite
                avec les facultés affaiblies sont beaucoup plus strictes.{' '}
            </h2>
            <p>
                <strong>
                    Avocats Alcool au Volant vous explique les chances de succès
                    d’une défense Carter en 2025!
                </strong>
            </p>
            <h2></h2>
            <h2>
                <strong>
                    Dans quelles circonstances un individu est-il reconnu
                    coupable de conduite avec facultés affaiblies par l'alcool?
                </strong>
            </h2>
            <p>
                La conduite avec les facultés affaiblies par l'alcool, définie à{' '}
                <Link to="https://laws-lois.justice.gc.ca/fra/lois/c-46/page-46.html%22%20/l%20%22h-118094">
                    l'article 320.14
                </Link>{' '}
                du Code criminel, survient principalement dans deux cas :
            </p>
            <ul>
                <li>
                    Lorsqu’une personne conduit un véhicule avec des capacités
                    affaiblies à un quelconque degré par l’effet de l’alcool ou
                    d’une drogue, ou par l’effet combiné de l’alcool et d’une
                    drogue.
                </li>
                <li>
                    Lorsque la concentration d'alcool dans le sang de l’individu
                    atteint ou dépasse 80 milligrammes par 100 millilitres de
                    sang, et ce, dans les deux heures suivant la fin de sa
                    conduite.
                </li>
            </ul>
            <p>
                Évidemment, la personne n’a pas commis une infraction s’il a
                consommé de l’alcool dans les deux heures suivant sa conduite et
                qu’il n’avait aucune raison de croire qu’il serait amené à
                fournir un échantillon d’haleine ou de sang.
            </p>
            <h3>
                Fardeau de la preuve pour qu’un individu soit reconnu coupable :
            </h3>
            <p>
                Le procureur de la Couronne responsable de faire la preuve
                qu’une personne a conduit avec les facultés affaiblies devra
                démontrer les trois éléments suivants:
            </p>
            <ul>
                <li>
                    <strong>L'identité du conducteur:</strong> L’accusé était
                    bien celui qui conduisait ou avait le contrôle ou la garde
                    du véhicule au moment des faits reprochés.
                </li>
                <li>
                    <strong>
                        Le fait de conduire ou de contrôler le véhicule:{' '}
                    </strong>
                    L'accusé conduisait un véhicule ou en avait le contrôle au
                    moment de l'infraction. Si l'accusé est trouvé derrière le
                    volant, il est présumé avoir le contrôle du véhicule. La loi
                    interdit non seulement de conduire avec les facultés
                    affaiblies, mais aussi de{' '}
                    <Link to="https://avocatsalcoolauvolant.ca/accusation-garde-controle-alcool/">
                        contrôler le véhicule
                    </Link>
                    .
                </li>
                <li>
                    <strong>
                        L’affaiblissement des capacités de conduite:
                    </strong>{' '}
                    Les facultés de l’accusé étaient altérées par l’alcool et/ou
                    les drogues à un tel degré qu’il ne pouvait plus conduire en
                    toute sécurité.
                </li>
            </ul>
            <p>
                Alternativement, il peut démontrer que, dans les
                <strong> deux heures suivant la fin de la conduite, </strong>le
                taux d’alcool dans son sang dépassait la limite légale autorisée
                (80 mg d'alcool par 100 ml de sang).
            </p>
            <p>
                <Img
                    fluid={data.img1.childImageSharp.fluid}
                    title="Fardeau de la preuve en cas d’alcool au volant!"
                    alt=""
                />
            </p>
            <p>
                Si la poursuite ne parvient pas à prouver ces trois éléments
                au-delà de tout doute raisonnable, l’accusé sera acquitté.
            </p>
            <h2>
                <strong>Qu’est-ce que la défense Carter ?</strong>
            </h2>
            <p>
                La défense Carter, également connue sous le nom de défense des «
                deux bières », est une stratégie utilisée pour contester des
                accusations de conduite avec facultés affaiblies par l'alcool.
            </p>
            <p>
                Elle trouve son origine dans l'affaire <em>R. c. Carter</em> de
                1985, où la Cour d'appel de l'Ontario a reconnu qu'un accusé
                pouvait introduire un doute raisonnable sur son état
                d'intoxication au moment de l'arrestation.
            </p>
            <p>
                L’objectif de cette défense est de démontrer que, malgré un taux
                d'alcool supérieur à la limite légale, l’accusé ne présentait
                pas des facultés affaiblies. Pour ce faire, la défense pouvait
                s'appuyer sur :
            </p>
            <ul>
                <li>
                    Des témoignages sur la quantité d’alcool consommée et le
                    temps écoulé depuis l’ingestion.
                </li>
                <li>
                    Des caractéristiques personnelles de l’accusé (âge, sexe,
                    poids, taille et tolérance à l'alcool).
                </li>
                <li>
                    Une expertise toxicologique visant à remettre en question la
                    fiabilité du test d’alcoolémie.
                </li>
            </ul>
            <table>
                <tr>
                    <td>
                        <p>
                            L’objectif est de montrer que, compte tenu de la
                            consommation d'alcool et des caractéristiques
                            individuelles de l'accusé, il est raisonnable de
                            douter de la précision de l’alcootest..
                        </p>
                        <p>
                            En présentant des preuves médicales et des
                            témoignages, l'objectif est de convaincre le
                            tribunal qu'il{' '}
                            <strong>existe un doute raisonnable</strong> quant à
                            l'intoxication de l'accusé!
                        </p>
                    </td>
                </tr>
            </table>
            <h3>Une défense autrefois couramment acceptée</h3>
            <p>
                Avant 2008, la défense Carter était largement acceptée et
                permettait à de nombreux accusés d’obtenir un acquittement, même
                avec un taux d’alcool supérieur à 0,08. En plaidant que leur
                consommation d’alcool n’avait pas altéré leurs capacités, ils
                pouvaient remettre en cause la fiabilité des tests et éviter une
                condamnation.
            </p>
            <p>
                <Img
                    fluid={data.img2.childImageSharp.fluid}
                    title="Qu’est-ce que la défense de type Carter ?"
                    alt=""
                />
            </p>
            <p>
                En réponse aux critiques, des modifications législatives ont été
                adoptées en 2008 pour restreindre l’application de cette défense
                et imposer des critères plus stricts en matière de preuve.
            </p>
            <h2>
                <strong>
                    La modification législative de 2008: un durcissement de la
                    défense Carter!
                </strong>
            </h2>
            <p>
                En 2008, le gouvernement canadien a réformé la législation
                canadienne sur la conduite avec facultés affaiblies, en limitant
                l'utilisation de la défense de type Carter.{' '}
            </p>
            <h3>
                Les principales modifications introduites par le gouvernement en
                2008:
            </h3>
            <p>
                Les nouvelles dispositions législatives ont imposé des critères
                beaucoup plus stricts pour les accusés souhaitant invoquer la
                défense Carter en contestant les résultats des alcootests.
                Désormais,{' '}
                <strong>
                    un simple témoignage sur la consommation d'alcool de
                    l'accusé n’est plus suffisant.
                </strong>
            </p>
            <p>L'accusé devait désormais prouver trois éléments :</p>
            <ul>
                <li>
                    Un doute raisonnable sur le fonctionnement et/ou
                    l’utilisation incorrecte de l’alcootest,
                </li>
                <li>
                    Le résultat d’analyse provient du mauvais fonctionnement ou
                    l’utilisation incorrecte de l’alcootest, ou{' '}
                </li>
            </ul>
            <p>Le taux d’alcool ne dépassait pas la limite permise.</p>
            <p>
                Ces changements avaient pour but de renforcer la fiabilité des
                tests d'alcoolémie, considérés comme scientifiquement valides,
                en excluant les défenses fondées sur des éléments vagues ou
                insuffisants.
            </p>
            <h2>Les modifications de 2008 sont-elles valides?</h2>
            <p>
                L'une des grandes questions soulevées par ces réformes de 2008
                était leur conformité avec la Charte canadienne des droits et
                libertés.
            </p>
            <h3>
                Les modifications de 2008 allaient à l'encontre du principe de
                la présomption d'innocence!
            </h3>
            <p>
                Selon plusieurs, les nouvelles exigences violaient les droits
                fondamentaux des accusés, notamment leur droit à une défense
                pleine et entière, garanti par l'Article 7 de la Charte
                canadienne des droits et libertés.
            </p>
            <p>
                <Img
                    fluid={data.img3.childImageSharp.fluid}
                    title="Modifications de la défense de type Carter!"
                    alt=""
                />
            </p>
            <p>
                Le principal enjeu était la présomption selon laquelle les
                résultats de l’alcootest étaient exacts. Cela forcait l’accusé à
                faire la preuve qu’il ne l’était pas. Pour plusieurs, cela
                allait à l’encontre du principe de{' '}
                <strong>présomption d’innocence</strong>.{' '}
            </p>
            <h2>
                L'arrêt Lamoureux de 2012 : décision rectifiant la défense
                Carter!
            </h2>
            <p>
                En 2012, la Cour supr<strong>ême du Canada</strong> a jugé que
                certaines des
                <strong>
                    {' '}
                    exigences introduites par la réforme de 2008 étaient
                    inconstitutionnelles!
                </strong>
            </p>
            <p>
                La Cour a contesté les articles du Code criminel imposant à
                l'accusé de prouver l'erreur des résultats d'alcoolémie en
                raison d'un mauvais fonctionnement de l'appareil ou d'une
                mauvaise utilisation. La Cour a estimé qu'il n'était pas
                justifié de forcer l'accusé à démontrer le dysfonctionnement de
                l'alcootest avant même qu'un doute raisonnable sur sa validité
                ne soit soulevé.{' '}
            </p>
            <p>
                <strong>Éléments invalidés de la réforme de 2008 :</strong>
            </p>
            <p>
                La Cour a invalidé plusieurs aspects des modifications apportées
                en 2008, notamment :
            </p>
            <table>
                <tr>
                    <td>
                        <p>
                            <strong>Éléments invalidés</strong>
                        </p>
                    </td>
                    <td>
                        <p>
                            <strong>Explication</strong>
                        </p>
                    </td>
                </tr>
                <tr>
                    <td>
                        <p>
                            Le fardeau à l'accusé de soulever un doute
                            raisonnable sur le bon fonctionnement de l’alcootest
                        </p>
                    </td>
                    <td>
                        <p>
                            Exiger de l'accusé qu'il prouve un problème avec
                            l’appareil, puis démontrer un lien entre ce problème
                            et un taux d'alcool supérieur à la limite légale
                            constitue une atteinte à la présomption d'innocence.
                        </p>
                    </td>
                </tr>
                <tr>
                    <td>
                        <p>
                            Exigence de prouver que l'alcoolémie de l'accusé ne
                            dépassait pas la limite légale
                        </p>
                    </td>
                    <td>
                        <p>
                            La Cour a également estimé que la nécessité pour
                            l'accusé de démontrer que son taux d'alcoolémie
                            était inférieur à 0,08 % au moment de l'infraction
                            était injustifiée.
                        </p>
                        <p>
                            En effet, une fois qu'un doute raisonnable a été
                            soulevé quant à la fiabilité des résultats du test,
                            cette exigence devient inutile.
                        </p>
                    </td>
                </tr>
            </table>
            <p>
                La Cour a estimé que les modifications législatives de 2008
                empiétaient sur les droits constitutionnels des accusés et a
                annulé certaines de ces règles tout en maintenant la nécessité
                de prouver une mauvaise utilisation ou un dysfonctionnement de
                l'alcootest.
            </p>
            <h2>
                Est-ce que la défense de type Carter est admissible en 2025 ?
            </h2>
            <p>
                ​En 2025, la défense de type Carter est toujours théoriquement
                disponible pour les accusations de conduite avec facultés
                affaiblies par l'alcool! Cependant, l'admissibilité de cette
                défense a été restreinte par des modifications récentes du Code
                criminel.
            </p>
            <p>
                <Img
                    fluid={data.img4.childImageSharp.fluid}
                    title="La défense Carter est-elle encore admissible en 2025 ?"
                    alt=""
                />
            </p>
            <p>
                Ces changements ont rendu plus difficile la contestation des
                résultats des alcootests en exigeant des accusés qu'ils
                démontrent des erreurs ou des irrégularités spécifiques dans la
                collecte, le stockage ou l'analyse des échantillons. Ainsi, des
                preuves concrètes sont désormais nécessaires pour établir un
                doute raisonnable quant à l'intégrité des résultats de
                l’alcootest.
            </p>
            <h3>
                La fiabilité des appareils de détection d'alcool dans le cadre
                de la défense Carter
            </h3>
            <p>
                La Cour suprême du Canada a affirmé le droit de contester la
                fiabilité des appareils de détection d'alcool dans le cadre
                d'une défense. Cependant, la défense Carter, telle qu'elle a été
                initialement formulée,{' '}
                <strong>n'est pas applicable en 2025!</strong>
            </p>
            <p>
                La défense Carter doit être utilisée uniquement pour contester
                l'exactitude des résultats des alcootests, et non pour établir,
                en fonction des circonstances personnelles du conducteur ou de
                sa consommation d'alcool, que le taux d'alcool mesuré ne peut
                pas être exact!
            </p>
            <p>
                Cette défense ne permet plus de contester la validité des
                résultats sur la base des spécificités individuelles du
                conducteur!
            </p>
            <table>
                <tr>
                    <td>
                        <p>
                            <strong>
                                L'accès aux documents relatifs à l'entretien et
                                à la réparation des appareils:
                            </strong>
                        </p>
                        <p>
                            Pour invoquer la défense Carter et soulever un doute
                            raisonnable sur l'exactitude des résultats de
                            l’alcootest, les avocats de la défense peuvent
                            demander l'accès aux documents relatifs à
                            l'entretien et à la réparation des appareils.
                        </p>
                        <p>
                            Cette démarche permet d'identifier d'éventuelles
                            irrégularités dans leur fonctionnement, susceptibles
                            de remettre en question la fiabilité des résultats
                            et de mettre en doute l'alcoolémie de l'accusé.
                        </p>
                    </td>
                </tr>
            </table>

            <h2>
                Les autres moyens de défense qui peuvent être soulevés à la
                place de la défense Carter!
            </h2>
            <p>
                Malgré les restrictions apportées à la défense Carter, plusieurs
                autres{' '}
                <Link to="https://avocatsalcoolauvolant.ca/defenses-alcool-volant/">
                    moyens de défense
                </Link>{' '}
                peuvent être invoqués dans les cas de conduite avec facultés
                affaiblies.
            </p>
            <p>Parmi ceux-ci, on retrouve :</p>
            <ul>
                <li>La violation du droit à l'assistance d'un avocat</li>
                <li>Le droit de connaître les motifs de l'arrestation</li>
                <li>
                    La violation du droit à un jugement dans un délai
                    raisonnable
                </li>
                <li>L'intoxication involontaire</li>
            </ul>
            <p>
                <strong>
                    N’hésitez pas à faire appel à un avocat pour savoir si une
                    défense s’applique à votre cas!
                </strong>
            </p>
            <h2>
                <strong>
                    Vous avez été arrêté pour alcool au volant? Consultez un
                    avocat spécialisé en droit criminel!
                </strong>
            </h2>
            <p>
                Si vous êtes accusé de conduite avec facultés affaiblies par
                l'alcool, il est fortement conseillé de consulter un avocat
                spécialisé en droit criminel!
            </p>
            <p>
                Un avocat expérimenté dans ce domaine pourra examiner les
                détails de votre dossier et identifier les moyens de défense
                applicables, comme la défense de type Carter, qui permet de
                soulever un doute raisonnable quant à l'exactitude des résultats
                des alcootests.
            </p>
            <p>
                <Img
                    fluid={data.img5.childImageSharp.fluid}
                    title="Avocat pour défense de type Carter!"
                    alt=""
                />
            </p>
            <p>
                <strong>
                    Avec notre formulaire rapide et gratuit, vous pourrez
                    facilement trouver un avocat spécialisé en droit criminel !
                </strong>
            </p>
            <p>
                <strong>
                    Suite à votre demande, nous vous mettrons rapidement en
                    contact avec un avocat près de chez vous. Ce processus ne
                    nécessite aucun engagement de votre part !
                </strong>
            </p>
        </SeoPage>
    )
}

export default ContentPage

export const pageQuery = graphql`
    query ($language: String!) {
        locales: allLocale(filter: { language: { eq: $language } }) {
            edges {
                node {
                    ns
                    data
                    language
                }
            }
        }
        img0: file(
            relativePath: {
                eq: "defense-carter-alcool-volant/infraction-conduite-faculte-affaiblies-alcool.jpeg"
            }
        ) {
            childImageSharp {
                fluid(maxWidth: 960) {
                    ...GatsbyImageSharpFluid
                }
            }
        }
        img1: file(
            relativePath: {
                eq: "defense-carter-alcool-volant/fardeau-preuve-alcool-volant.jpeg"
            }
        ) {
            childImageSharp {
                fluid(maxWidth: 960) {
                    ...GatsbyImageSharpFluid
                }
            }
        }
        img2: file(
            relativePath: {
                eq: "defense-carter-alcool-volant/defense-type-carter-alcool-volant.jpeg"
            }
        ) {
            childImageSharp {
                fluid(maxWidth: 960) {
                    ...GatsbyImageSharpFluid
                }
            }
        }
        img3: file(
            relativePath: {
                eq: "defense-carter-alcool-volant/modifications-defense-carter-alcool-volant.jpeg"
            }
        ) {
            childImageSharp {
                fluid(maxWidth: 960) {
                    ...GatsbyImageSharpFluid
                }
            }
        }
        img4: file(
            relativePath: {
                eq: "defense-carter-alcool-volant/defense-carter-alcool-volant-2025.jpeg"
            }
        ) {
            childImageSharp {
                fluid(maxWidth: 960) {
                    ...GatsbyImageSharpFluid
                }
            }
        }
        img5: file(
            relativePath: {
                eq: "defense-carter-alcool-volant/avocat-defense-carter-alcool-volant.jpeg"
            }
        ) {
            childImageSharp {
                fluid(maxWidth: 960) {
                    ...GatsbyImageSharpFluid
                }
            }
        }
    }
`
